// The visitor's public IP address, for lead payloads.
//
// A browser cannot see its own public IP — that value only exists at the
// network edge. So we ask a CORS-enabled IP echo service for it and cache the
// answer for the session. ipwho.is is the same keyless service the geo lookup
// already uses, so this adds no new vendor.
//
// This is best effort. Ad blockers, privacy browsers, and outages will all
// leave it empty, and a lead must NEVER be blocked on it. When the receiving
// system requires a trustworthy IP, it should read the one its own server sees
// on the request rather than trusting this value.

let cached = ''
let inFlight: Promise<string> | null = null

/** Kick off the lookup early (e.g. on page mount) so it is ready at submit. */
export function prefetchClientIp(): void {
  void fetchClientIp()
}

export function fetchClientIp(): Promise<string> {
  if (cached) return Promise.resolve(cached)
  if (inFlight) return inFlight

  inFlight = fetch('https://ipwho.is/')
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      cached = typeof data?.ip === 'string' ? data.ip : ''
      return cached
    })
    .catch(() => '')
    .finally(() => {
      inFlight = null
    })

  return inFlight
}

/** The IP if it has already resolved, otherwise an empty string. */
export function getClientIp(): string {
  return cached
}
